import { Bell, Brain } from 'lucide-react';
import { AppHeaderBar } from '../../ui-foundation';
import { AppIconButton } from '../../ui-foundation/adapters/web';

interface AppHeaderProps {
  title?: string;
  onBellTap: () => void;
  onQuickAddTap: () => void;
  attentionCount?: number;
  hasNotificationItems?: boolean;
}

export default function AppHeader({
  title,
  onBellTap,
  onQuickAddTap,
  attentionCount = 0,
  hasNotificationItems = false,
}: AppHeaderProps) {
  const hasAttentionItems = attentionCount > 0;

  return (
    <AppHeaderBar
      title={title}
      action={(
        <div className="flex items-center gap-1">
          <AppIconButton
            onClick={onQuickAddTap}
            className="p-2 rounded-full transition-transform active:scale-90"
            aria-label="Brain Dump"
          >
            <Brain size={20} className="text-primary" strokeWidth={1.8} />
          </AppIconButton>
          <AppIconButton
            onClick={onBellTap}
            className={`relative -mr-2 -mt-1 rounded-full p-2 transition-transform active:scale-90 ${
              hasAttentionItems
                ? hasNotificationItems
                  ? 'bg-destructive/10 text-destructive'
                  : 'bg-primary/10 text-primary'
                : ''
            }`}
            aria-label="Things To Do"
          >
            <Bell
              size={20}
              className={hasAttentionItems ? (hasNotificationItems ? 'text-destructive' : 'text-primary') : 'text-primary'}
              strokeWidth={hasAttentionItems ? 2.2 : 1.8}
            />
            {hasAttentionItems && (
              <span
                className={`absolute -right-1 -top-1 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-bold text-white ${
                  hasNotificationItems ? 'bg-destructive' : 'bg-primary'
                }`}
              >
                {attentionCount > 9 ? '9+' : attentionCount}
              </span>
            )}
          </AppIconButton>
        </div>
      )}
    />
  );
}
